const get_base_uri = () => {
    if (process.env.NODE_ENV == "development") {
        return "http://localhost:8000/api";
    }
    else {
        return "https://vcreate.io/api"
    }
}

export const BASE_URI = get_base_uri();

export function prettyPrintDate(dateString: string): string {
    const months = [
        "Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.",
        "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
    ];
    
    const parts = dateString.split('-');
    const year = parts[0];
    const month = months[parseInt(parts[1]) - 1];
    const day = parseInt(parts[2]);

    return `${month} ${day}, ${year}`;
}